import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { DropdownList } from '../../../common/dropdown/DropdownList'
import { UseI18n } from '../../../common/hooks/useI18n'
import { InputDropdown } from '../../../common/html/input/InputDropdown'
import { ScrollComponent } from '../../../common/scrollComponent'
import { removeAccents } from '../../../helpers/common'
import { POPUP_FIELDS_KEYS } from '../constants'
import { setListFieldRequest } from '../store/slice'

export const SelectIndustry = ({
  vsics,
  activeIndustry,
  setIndustry,
  listFieldRequest,
  isValid,
  setIsValid,
}) => {
  const dispatch = useDispatch()

  const [inputValue, setInputValue] = useState(activeIndustry?.name)
  const [isShowDropdown, setIsShowDropdown] = useState(false)

  const onChangeInput = (e) => {
    setInputValue(e.target.value)
  }

  const onClick = () => {
    setIsShowDropdown(true)
  }

  const onFocus = () => {
    setIsShowDropdown(true)
    setInputValue('')
  }

  const handleClickOutside = () => {
    setInputValue(activeIndustry?.name)
    setIsShowDropdown(false)
  }

  const onChooseItem = (value) => {
    setIndustry(value)
    setInputValue(value?.name)
    setIsValid((prev) => ({
      ...prev,
      [POPUP_FIELDS_KEYS.INDUSTRY]: true,
    }))
    setIsShowDropdown(false)
  }

  const list = [
    ...vsics?.filter(
      (item) =>
        !!item?.label &&
        removeAccents(item?.label?.toLowerCase()).includes(
          removeAccents(inputValue?.trim().toLowerCase()),
        ),
    ),
  ]

  useEffect(() => {
    const newListFieldRequest = listFieldRequest.map((obj) => {
      if (obj.fieldCode === 'CompanyVSICId') {
        return { ...obj, inputValue: activeIndustry?.id }
      }
      return obj
    })
    dispatch(setListFieldRequest(newListFieldRequest))
  }, [activeIndustry])

  return (
    <div>
      <InputDropdown
        type="text"
        containerStyle={{ width: 280, marginLeft: 5, height: 28 }}
        style={{
          paddingLeft: 12,
        }}
        isShowDropdown={isShowDropdown}
        onClickOutsideDropdown={handleClickOutside}
        onClick={onClick}
        value={inputValue || ''}
        onChange={onChangeInput}
        inputProps={{ noControl: true, onFocus }}
        zIndexDropdown={99}
        isShowIconSelect
        isShowIcon={false}
        dropdownContentStyle={{
          padding: 0,
        }}
        styleIcon={{
          marginRight: 4,
        }}
        isValid={isValid}
        textInvalid={UseI18n('userManagement.valid.industry')}
        onClickIcon={onFocus}
      >
        <ScrollComponent autoHeight autoHeightMax={300}>
          <DropdownList
            activeItem={activeIndustry}
            data={!!list.length ? list : []}
            onClickItem={onChooseItem}
          />
        </ScrollComponent>
      </InputDropdown>
    </div>
  )
}
